<template>
  <section>
    <WrapperFollowersByChannel
      v-if="allChannels"
      :key="keyFollowersByChannel"
    />

    <div v-else>
      <FanbaseEvolution />
    </div>

    <FanbaseGrowthTable />
  </section>
</template>

<script>
import { WrapperFollowersByChannel } from '@/components/content/FollowersByChannel';
import { FanbaseEvolution } from '@/components/content/FanbaseEvolution';
import { FanbaseGrowthTable } from '@/components/content/tables/FanbaseGrowthTable';

export default {
  name: 'SectionFanbase',
  components: {
    WrapperFollowersByChannel,
    FanbaseEvolution,
    FanbaseGrowthTable,
  },
  props: {
    keyFollowersByChannel: {
      type: Number,
      required: true,
    },
  },
  computed: {
    allChannels() {
      return this.$store.state.ui.channel === 'Todas';
    },
  },
};
</script>
